import { render } from "./index.vue?vue&type=template&id=cf2e6780"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentBase/BaseSpecs/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cf2e6780"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cf2e6780', __exports__)) {
    api.reload('cf2e6780', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=cf2e6780", () => {
    api.rerender('cf2e6780', render)
  })

}


export default __exports__